import type { CSSProperties, ReactNode } from 'react';

type CardProps = {
  pad?: boolean;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
};

/**
 * Surface container shared by every panel in the MAFA design system.
 * `pad` toggles the standard 22 px interior spacing — useful when the
 * caller renders a CardHead + its own padded body.
 */
export function Card({ pad, children, className, style }: CardProps) {
  const classes = ['card'];
  if (pad) classes.push('pad');
  if (className) classes.push(className);
  return (
    <div className={classes.join(' ')} style={style}>
      {children}
    </div>
  );
}

type CardHeadProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  right?: ReactNode;
};

export function CardHead({ title, subtitle, right }: CardHeadProps) {
  return (
    <div className="card-head">
      <span className="ct">{title}</span>
      {subtitle && <span className="cs">{subtitle}</span>}
      {right && <span className="ch-right">{right}</span>}
    </div>
  );
}
